/**
 * @deprecated Import `useCountryData` from `@/modules/shared/hooks/use-country-data` instead.
 * This stub re-exports a compatibility wrapper and will be removed once all consumers are migrated.
 */
import useCountryData from "@/modules/shared/hooks/use-country-data";

const useDefaultCountry = countryValue => {
  const { resolvedCountry } = useCountryData({ countryValue });
  return resolvedCountry;
};

export default useDefaultCountry;
